import React from 'react'

/**
 * @param {any} props
 */
const Cross = (props) => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.638 23.688l18.738 18.738-4.95 4.95-18.738-18.738L4.95 47.376 0 42.426l18.738-18.738L0 4.95 4.95 0l18.738 18.738L42.427 0l4.95 4.95-18.74 18.738z"
    />
  </svg>
)

export default Cross
